import { Injectable } from '@angular/core';
import { AppTopLevelCategory } from './APP_TABBED_FILTERS_CONFIG';

@Injectable()
export class TabbedFilterGroup {
  key: string;
  label: string;
  selected: boolean;
  items: TabbedFilterItem[];
  collapsed?: boolean;
  hidden?: boolean;
  hiddenFor?: string[];
}

@Injectable()
export class TabbedFilterItem {
  param: string;
  label: string;
  previousSearchString: string;
  searchString: string;
  optionsLoading: boolean;
  optionsCount: number;
  type: string;
  minValue: number;
  maxValue: number;
  fromValue: number;
  toValue: number;
  initMaxValue?: number;
  updateMaxValue?: boolean;
  multiple: boolean;
  metadataKey: string;
  rangeStep: number;
  hideSearch: boolean;
  hidden: boolean;
  hiddenFor?: string[];
  rangePercent: boolean;
  options: any[];
  labelFormat?: string;
  permission?: string;
  selected?: boolean;
}

@Injectable()
export class TabbedFilterItemValue {
  param: string;
  label: string;
  valueLabel: string;
  value: string;
}

export const DAY_STRINGS: Array<string> = [
  '',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const DOMAIN_DISCOVERY_FACETS = [
  'adultContentRating',
  'alcoholContentRating',
  'brandSafetyRisk',
  'dayOfWeek',
  'drugContentRating',
  'facebookRating',
  'hasCookieBanner',
  'hasPrivacyLink',
  'hasTermsOfServiceLink',
  'hateContentRating',
  'isAdsDotTxtExist',
  'isSubDomain',
  'isVideoAvailable',
  'linkedinRating',
  'mfaRating',
  'ownerDomain',
  'peakDay',
  'peakHour',
  'primaryDevice',
  'risk',
  'trafficSource',
  'twitterRating'
];

export const DOMAIN_TOP_LEVEL_CATEGORIES: AppTopLevelCategory[] = [
  {
    key: 'domain-iabcategory-toplevel-category',
    label: 'IAB Categories',
    groups: [
      {
        label: 'IAB Categories',
        key: 'domain-pixalate-iabcategory-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'iabPrimaryCategory',
            label: 'Primary Categories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'iabSubCategory',
            label: 'Sub Categories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'domain-risk-toplevel-category',
    label: 'Risk',
    groups: [
      {
        label: 'Risk',
        key: 'domain-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'risk',
            label: 'Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Site Rank',
        key: 'domain-site-rank-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'rank',
            label: 'Rank',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 3000000,
            fromValue: 0,
            toValue: 3000000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: true,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Fraud Risk',
        key: 'domain-ad-fraud-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'givtSivtRate',
            label: 'IVT%',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'Brand Safety Risk',
        key: 'domain-brand-safety-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'brandSafetyRisk',
            label: 'Brand Safety Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'adultContentRating',
            label: 'Adult Content',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'alcoholContentRating',
            label: 'Alcohol Content',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'drugContentRating',
            label: 'Drug Content',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hateContentRating',
            label: 'Hate Content',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'facebookRating',
            label: 'Facebook',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'linkedinRating',
            label: 'Linkedin',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'twitterRating',
            label: 'Twitter',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Marketing Compliance Risk',
        key: 'domain-marketing-compliance-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isAdsDotTxtExist',
            label: 'Ads.txt',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Enabled', value: 'T', selected: false },
              { icon: '', text: 'Disabled', value: 'F', selected: false }
            ],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'domain-mfa-toplevel-category',
    label: 'Made for Advertising (MFA)',
    groups: [
      {
        label: 'MFA Risk',
        key: 'domain-mfa-rating-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'mfaRating',
            label: 'MFA Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Refresh Rate',
        key: 'domain-ad-refresh-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adRefreshRate',
            label: 'Ad Refresh Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 50,
            fromValue: 0,
            toValue: 50,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Density',
        key: 'domain-ad-density-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adDensity',
            label: 'Ad Density',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 30,
            fromValue: 0,
            toValue: 30,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Social Traffic Rate',
        key: 'domain-social-traffic-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'socialTrafficRate',
            label: 'Social Traffic Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'Paid Traffic Rate',
        key: 'domain-paid-traffic-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'paidTrafficRate',
            label: 'Paid Traffic Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      }
    ]
  },
  {
    key: 'domain-publisher-toplevel-category',
    label: 'Publisher',
    groups: [
      {
        label: 'Publisher Details',
        key: 'domain-publisher-details-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'familyOfSites',
            label: 'Family of Sites',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'registrantEmail',
            label: 'Registrant Email',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'ownerDomain',
            label: 'Owner Domain',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: '',
    label: 'User Engagement',
    permission: 'mrtDomainEngagement',
    groups: [
      {
        label: 'mau',
        key: 'domain-mau-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'mau',
            label: 'Monthly Active Users',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'totalSessions',
        key: 'domain-total-session-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'totalSessions',
            label: 'Total Sessions',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'pagesPerSession',
        key: 'domain-pages-per-session-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'pagesPerSession',
            label: 'Pages per Session',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'sessionDuration',
        key: 'domain-session-duration-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'sessionDuration',
            label: 'Session Duration',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      }
    ]
  },
  {
    key: '',
    label: 'Ad Behavior',
    permission: 'mrtDomainEngagement',
    groups: [
      {
        label: 'Ad Viewability',
        key: 'domain-viewability-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'nonGivtSivtViewability',
            label: 'Ad Viewability',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'App Performance',
        key: 'domain-performance-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'nonGivtSivtCtr',
            label: 'CTR',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 3,
            fromValue: 0,
            toValue: 3,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'adsPerPage',
        key: 'domain-ads-per-page-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adsPerPage',
            label: 'Ads per page',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'adViewTime',
        key: 'domain-ad-view-time-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adViewTime',
            label: 'Ad View Time',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      }
    ]
  },
  {
    key: 'domain-user-behavior',
    label: 'User Behavior',
    permission: 'mrtDomainEngagement',
    groups: [
      {
        label: 'peakHour',
        key: 'domain-peak-active-hour-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'peakHour',
            label: 'Peak Active Hour',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 24,
            fromValue: 0,
            toValue: 24,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      },
      {
        label: 'peakDay',
        key: 'domain-peak-active-day-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'peakDay',
            label: 'Peak Active Day',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 7,
            fromValue: 0,
            toValue: 7,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      }
    ]
  },
  {
    key: 'domain-site-toplevel-category',
    label: 'Site',
    groups: [
      {
        label: 'Ad Capabilities',
        key: 'domain-ad-capabilities-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adSize',
            label: 'Ad Sizes',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'isVideoAvailable',
            label: 'Video Available?',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Bid Range',
        key: 'domain-price-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'priceBid',
            label: 'Bid Range',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 20,
            fromValue: 0,
            toValue: 20,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Daypart',
        key: 'domain-daypart-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'dayOfWeek',
            label: 'Day of the Week',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Device',
        key: 'domain-device-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'os',
            label: 'Top OS',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'primaryDevice',
            label: 'Primary Device',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Desktop', value: 'desktop', selected: false },
              { icon: '', text: 'Mobile', value: 'mobile', selected: false },
              { icon: '', text: 'Video', value: 'video', selected: false }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Geo',
        key: 'domain-geo-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'country',
            label: 'Top Country',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'state',
            label: 'Top State',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'dma',
            label: 'Top DMA',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Privacy Policy',
        key: 'domain-privacy-policy-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'hasPrivacyLink',
            label: 'Privacy Policy',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Cookie Banner',
        key: 'domain-cookie-banner',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'hasCookieBanner',
            label: 'Cookie Banner',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtDomainCookieBanner'
          }
        ]
      },
      {
        label: 'Reach',
        key: 'domain-reach-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'totalInventory',
            label: 'Inventory Available',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 50000000000,
            fromValue: 0,
            toValue: 50000000000,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: true,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Terms and Conditions Detected',
        key: 'domain-terms-conditions-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'hasTermsOfServiceLink',
            label: 'Terms and Conditions Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Seller',
        key: 'domain-seller-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'trustedSellerName',
            label: 'Trusted Seller',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Top Level Domain',
        key: 'domain-tld-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'tld',
            label: 'Top Level Domain',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Top Traffic Source',
        key: 'domain-source-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'trafficSource',
            label: 'Top Traffic Source',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Traffic',
        key: 'domain-traffic-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adWordsRatio',
            label: 'Ad Words',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'searchRatio',
            label: 'Search',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'paidRatio',
            label: 'Paid',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'socialRatio',
            label: 'Social',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'emailRatio',
            label: 'Email',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'directRatio',
            label: 'Direct',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'displayRatio',
            label: 'Display',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      }
    ]
  }
];
